import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ServiceCalendar from '../../../components/user/common/services/ServiceCalendar'
import ServiceCalendarAuth from '../../../components/user/common/services/ServiceCalendarAuth'
import { isLogin } from '../../../helpers/login'

const AppointmentModal = ({ 
  show, 
  onHide, 
  serviceId, 
  serviceName, 
  serviceCreator, 
  sellerId, 
  chargesPayStatus,
  onAppointmentScheduled 
}) => {
  const [isCalendarAuthorized, setIsCalendarAuthorized] = useState(false);
  
  const authInfo = JSON.parse(localStorage.getItem("authInfo"));
  const accessToken = localStorage.getItem("accessToken");
  const currentUser = isLogin();

  useEffect(() => {
    if (accessToken) {
      setIsCalendarAuthorized(true);
    }
  }, [accessToken]);

  const handleCalendarAuthorization = () => {
    setIsCalendarAuthorized(true);
  };

  const handleAppointmentSuccess = (appointmentData) => {
    if (onAppointmentScheduled) {
      onAppointmentScheduled(appointmentData);
    }
    onHide(); // Close modal after successful appointment
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Schedule Appointment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!currentUser ? (
          <div className="text-center p-4">
            <p className="text-muted">Please log in to schedule an appointment</p>
            <Button variant="primary" onClick={() => window.location.href = '/login'}>
              Login
            </Button>
          </div>
        ) : !isCalendarAuthorized ? (
          <div className="text-center">
            <ServiceCalendarAuth
              onAuthSuccess={handleCalendarAuthorization}
              userId={authInfo.id}
              authToken={authInfo.token}
              serviceCreator={serviceCreator}
              serviceName={serviceName}
              sellerId={sellerId}
            />
          </div>
        ) : (
          <div>
            <div className="mb-3">
              <h6>Service: {serviceName}</h6>
              <p className="text-muted">Select your preferred date and time</p>
            </div>
            <ServiceCalendar 
              authToken={authInfo.token} 
              serviceCreator={serviceCreator} 
              chargesPayStatus={chargesPayStatus} 
              serviceName={serviceName} 
              sellerId={sellerId}
              onAppointmentScheduled={handleAppointmentSuccess}
            />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AppointmentModal;